<template>
  <div class="box" ref="place_ref"></div>
</template>

<script>
export default {
  data() {
    return {
      mychart: null,
      tableData: [],
    };
  },
  props: {
    barTags: Array
  },
watch: {
    barTags(){
       this.tableData = [];
       this.tableData = this.barTags;
       this.updateData();
    }
    
  },
  mounted() {
     console.log("fafas",this.barTags);
    this.initchart();
    this.getData();
  },
  methods: {
    initchart() {
      this.mychart = this.echarts.init(this.$refs.place_ref);
    },
    updateData() {
        const xData = this.tableData.map((item) => item.value);
    const yData = this.tableData.map((item) => item.key);
      const name = this.tableData.map((item) => item.name);
      // const name = this.tableData.name.map((item) => this.ojectList[item]);
      console.log(xData,yData,name);
      var color = [
        "#2ca1ff",
        "#0adbfa",
        "#febe13",
        "#65e5dd",
        "#7b2cff",
        "#fd5151",
        "#f071ff",
        "#85f67a",
        "#5ce0e2",
      ];
      
        const series = [];
      for (var i = 0; i < xData.length; i++) {
        series.push({
            name: name[i],
            type: 'bar',
            barGap: 0,
            emphasis: {
                focus: 'series'
            },
            data: xData[i]
            });
      }
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: name[0],
        },
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar", "stack"] },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            data: yData[0],
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series:series,
      };
      this.mychart.setOption(option);
    },
    // 获取事件
    async getData() {
      this.updateData();
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 400px;
  margin: 0 auto;
  & > div {
    height: 100%;
  }
  & > canvas {
    height: 100%;
  }
}
</style>